import { Typography } from '@mui/material'
import * as S from './DivPkMovementType.styles'

interface Props {
    isGondola: boolean;
    subtitle?: boolean;
    address: string;
}

export const DivPkMovementType = ({
  isGondola, subtitle, address,
}: Props) => (
  <>
    {isGondola
      ? (
        <S.DivPkMovementInfo style={{ backgroundColor: 'black' }}>
          <Typography variant='h6' color='white' fontWeight='bold'>DIRETO GÔNDOLA</Typography>
          {subtitle && <S.Subtitle style={{ color: 'white' }}>Dirija-se ao endereço indicado e bipe-o para confirmar</S.Subtitle>}
          <S.AddressBox>{address}</S.AddressBox>
        </S.DivPkMovementInfo>
      )
      : (
        <S.DivPkMovementInfo>
          <Typography variant='h6' color='black' fontWeight='bold'>REPOSIÇÃO DE EXCEDENTE</Typography>
          {subtitle && <S.Subtitle>Dirija-se ao endereço indicado e bipe-o para confirmar</S.Subtitle>}
          <S.AddressBox>{address}</S.AddressBox>
        </S.DivPkMovementInfo>
      )}
  </>
)
